import request from "@/utils/request";

const UPLOAD_IMAGE_URL = "/api/upload/image";

/**
 * 建议反馈截图（无需登录）
 * @param {File} file
 */
export function uploadFeedbackImage(file) {
  const formData = new FormData();
  formData.append("file", file);
  return request.post("/api/upload/image/feedback", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

/**
 * 统一图片上传（单文件）
 * @param {string} type 用途：'post' | 'avatar'
 * @param {File} file 图片文件
 * @returns {Promise<{ data: { code: number, data: string } }>} data 为图片 URL
 */
function uploadImage(type, file) {
  const formData = new FormData();
  formData.append("type", type);
  formData.append("file", file);
  return request.post(UPLOAD_IMAGE_URL, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function uploadPostImage(file) {
  return uploadImage("post", file);
}

export function uploadAvatarImage(file) {
  return uploadImage("avatar", file);
}
